import App from "./app"

new App(window.Telegram)
